module.exports = __webpack_public_path__ + "static/TQLD-Map.f7877949.jpg";